<template>
  <span class="vu-meter">
    <canvas
      :width="width"
      :height="height"
      v-draw-meter="{
        amp: dBVal,
        peak: dBPeakVal,
        clipSize: clipSize,
        showPeaks: showPeaks,
        newVolumePercentage: newVolumePercentage,
        volumeDefault: volumeDefault,
        previewId: previewId
      }"
    >
    </canvas>
  </span>
</template>
<script>

export default {
  props: {
    val: {
      type: Number,
      default: 0
    },
    peakVal: {
      type: Number,
      default: 0
    },
    refreshRate: {
      type: Number,
      default: 10
    },
    clipSize: {
      type: Number,
      default: 10
    },
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 150
    },
    showPeaks: {
      type: Boolean,
      default: false
    },
    newVolumePercentage: {},
    previewId: {
      type: String
    }
  },
  data () {
    return {
      volumeDefault: 440,
      pId: null,
      cIdx: null,
      isMute: false
    }
  },
  computed: {
    dBVal: function () {
      return 20 * Math.log10(this.val * 16)
    },
    dBPeakVal: function () {
      return 20 * Math.log10(this.peakVal)
    }
  },
  watch: {
    val: function (newVal) {
      if (this.showPeaks) {
        var smoothingFactor = 50
        if (newVal > this.peakVal) {
          this.peakVal = newVal
        } else {
          this.peakVal =
            newVal * (1 / smoothingFactor) +
            this.peakVal * ((smoothingFactor - 1) / smoothingFactor)
        }
      }
    }
  },
  directives: {
    drawMeter: function (canvas, binding) {
      var clipSize = binding.value.clipSize
      var amp = binding.value.amp / 60 + 0.8

      var w = canvas.width
      var h = canvas.height
      var currentVolumeLevel = (h * binding.value.newVolumePercentage) / 100
      if (currentVolumeLevel == undefined || isNaN(currentVolumeLevel)) {
        currentVolumeLevel = binding.value.volumeDefault
      } else if (currentVolumeLevel !== binding.value.volumeDefault) {
        binding.value.volumeDefault = currentVolumeLevel
      }
      var hInRange = currentVolumeLevel - clipSize
      var ctx = canvas.getContext('2d')
      var gradient = ctx.createLinearGradient(0, 0, 0, h)
      gradient.addColorStop(0, 'red')
      gradient.addColorStop(clipSize / h, 'red')
      gradient.addColorStop(clipSize / h, 'orange')
      gradient.addColorStop(1, 'lime')
      ctx.clearRect(0, 0, w, h)
      ctx.fillStyle = gradient
      // 距离顶部的距离
      const margin = (h - hInRange * amp)
      // 绿色高度
      const height = (currentVolumeLevel * amp)
      ctx.fillRect(0, margin, w, height)
      ctx.fillStyle = 'white'
      // 画白线
      ctx.fillRect(0, clipSize, w, 1)
    }
  }
}
</script>
<style
  scoped
>
.vu-meter {
  display: block;
  height: 100%;

}
canvas {
  height: 100% !important;
  width: 4px !important;
  background-color: #3d3f40;
}
</style>
